import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IServiceConfig } from '../../configurations/store/configurations.types'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPickupAddressOptionsState } from '../../options/store/options.types'
import * as destinationAddressActions from '../store/destinationAddress.actions'
import { getPickupAddressOptionsSelector } from '../../options/selectors/pickupAddressOptions.selector'
import { getPcrIdSelector } from '../../home/selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { DestinationAddressConstants } from '../store/destinationAddress.constants'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { initialDestinationAddressState, initialDispostionState } from '../store/destinationAddress.reducers'

export function* setRecAddressDefaults(pcr?: IPcr) {
  const serviceConfig: IServiceConfig = yield select(getServiceConfigSelector)
  const { RECTYPE_DEFAULT, RECUNIT_DEFAULT } = serviceConfig

  const pickupAddressOptions: IPickupAddressOptionsState = yield select(getPickupAddressOptionsSelector)
  const { locationTypeOptions, hospitalUnitOptions } = pickupAddressOptions
  const recDefaultType = locationTypeOptions.find((option) => option.id === RECTYPE_DEFAULT)
  let defaultunit
  if (recDefaultType?.id === 2 && RECUNIT_DEFAULT) {
    defaultunit = hospitalUnitOptions.find((option) => option.id === RECUNIT_DEFAULT)
  }
  if (pcr) {
    pcr.disposition = {
      ...initialDispostionState,
      typeValue: recDefaultType || null,
      hospitalInPatientDestination: defaultunit || null,
      destination: {
        ...initialDestinationAddressState,
        __areDefaultsSet: true,
      },
    }
    return
  }

  if (recDefaultType) yield put(destinationAddressActions.setTypeValue(recDefaultType))
  if (defaultunit) yield put(destinationAddressActions.setHospitalInPatientDestination(defaultunit))

  if (RECTYPE_DEFAULT === 1) yield put(destinationAddressActions.setDefaultEMSCode())
  if (RECTYPE_DEFAULT === 2) yield put(destinationAddressActions.setDefaultHospitalCode())
}

export function* setDestinationAddressDefaults() {
  try {
    const pcrID: string = yield select(getPcrIdSelector)
    const serviceId: string = yield select(getServiceIdSelector)
    if (pcrID) {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.disposition) {
        return
      }
      yield call(setRecAddressDefaults)
    }
  } catch (e) {
    yield put(throwPcrException(`setDestinationAddressDefaults() error: ${e}`))
  }
}

export function* setDestinationAddressDefaultsSaga() {
  yield takeLatest(
    [DestinationAddressConstants.SET_DESTINATION_ADDRESS_DEFAULTS],
    performWithMutexHOG,
    setDestinationAddressDefaults
  )
}
